var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.5 26.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.8 12.4h-9.2S120.2 0 140.6 0h2.9c-.3 3-.5 12.3-5.3 18-3.2 3.7-6.4 5.6-13.3 5.6h-15.4l2.4-8.4h11.3c1.4-.1 8.7.5 12.9-2.3 4.8-3.2 6.8-9 7.3-12.8-4.8.5-14.5 3-16.6 12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 23.2c-3.9 0-5-2.8-5-6.4s1.1-6.4 5-6.4 5 2.8 5 6.4-1.2 6.4-5 6.4zm-2.7-6.4c0 2.6.6 4.9 2.7 4.9s2.7-2.3 2.7-4.9-.6-4.9-2.7-4.9-2.7 2.3-2.7 4.9zm0-7.5V7.5h2v1.8h-2zm3.4 0V7.5h2v1.8h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 23h2v-3.7c0-2.1.8-2.9 2.8-2.9v-2.1c-1.7 0-2.3.9-2.8 1.8v-1.6h-2V23z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8 21.4c-.4.1-1 .3-1.6.3-2.4 0-3.2-1.7-3.2-2.9h5v-1.2c0-2.1-1.1-3.5-3.2-3.5-2.6 0-3.7 1.6-3.7 4 0 3.1 1.5 4.9 4.3 4.9.9 0 1.7-.1 2.4-.3v-1.3zm-4.9-3.7c0-.4 0-2.2 1.7-2.2s1.7 1.6 1.7 2.2h-3.4zM27.4 10.6h-2v8.7c0 2.5 1.3 3.8 3.6 3.8 2.8 0 3.6-2.1 3.6-4.5 0-2.7-.9-4.5-2.9-4.5-1.3 0-1.9.8-2.2 1.2v-4.7h-.1zm0 8.1c0-1.4.4-3.2 1.6-3.2 1.3 0 1.5 1.6 1.5 3.2 0 1.4-.2 3.1-1.5 3.1s-1.6-1-1.6-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1 23h2v-3.7c0-2.1.8-2.9 2.8-2.9v-2.1c-1.7 0-2.3.9-2.8 1.8v-1.6h-2V23z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3 23.2c2.5 0 3.8-1.7 3.8-4.5s-1.3-4.5-3.8-4.5-3.8 1.7-3.8 4.5c.1 2.8 1.4 4.5 3.8 4.5zm-1.6-4.5c0-1.6.2-3.1 1.6-3.1 1.4 0 1.6 1.5 1.6 3.1s-.2 3.1-1.6 3.1c-1.4 0-1.6-1.5-1.6-3.1zM52.4 23h2.2l1.1-3.3h4.4l1.1 3.3h2.2l-4.2-12.4h-2.5L52.4 23zm5.4-10.4 1.7 5.4h-3.4l1.7-5.4zM64.3 23h2v-8.5h-2V23zm0-10.2h2v-2h-2v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4 23h2v-3.7c0-2.1.8-2.9 2.8-2.9v-2.1c-1.7 0-2.3.9-2.8 1.8v-1.6h-2V23z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4 26.8h2v-4.9c.3.4.9 1.2 2.1 1.2 2.1 0 2.9-2 2.9-4.5 0-2.4-.7-4.5-2.9-4.5-1.1 0-1.9.9-2.1 1.4v-1.2h-2v12.5zm1.9-8.1c0-1.3.4-2.9 1.5-2.9 1.3 0 1.5 1.6 1.5 2.9 0 1.4-.2 2.9-1.5 2.9-1.1 0-1.5-1.3-1.5-2.9zM86.2 23.2c2.5 0 3.8-1.7 3.8-4.5s-1.3-4.5-3.8-4.5-3.8 1.7-3.8 4.5c.1 2.8 1.4 4.5 3.8 4.5zm-1.6-4.5c0-1.6.2-3.1 1.6-3.1 1.4 0 1.6 1.5 1.6 3.1s-.2 3.1-1.6 3.1c-1.4 0-1.6-1.5-1.6-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6 23h2v-3.7c0-2.1.8-2.9 2.8-2.9v-2.1c-1.7 0-2.3.9-2.8 1.8v-1.6h-2V23zM102.6 21.6c-.3.1-.6.1-.9.1-1.2 0-1.3-.9-1.3-1.9v-4h2.5v-1.4h-2.5v-3.2l-2 1.2v2h-1.7v1.4h1.7v5c0 1.3.4 2.3 2.6 2.3.5 0 1.1-.1 1.6-.1v-1.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOaLogo);
export default __webpack_public_path__ + "static/media/oa-logo.dca81bce66452b69a4d3e75814032e39.svg";
export { ForwardRef as ReactComponent };